/**
 * @generated SignedSource<<ae8eb7b6fe2c14274cb2982fb5591ab2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type MemberGroupKind = "custom" | "default" | "role" | "test_user" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MemberGroupMoreActionsDropdownFragment$data = {
  readonly id: string;
  readonly kind: MemberGroupKind;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteSubGroupButtonFragment" | "EditMemberGroupButtonFragment">;
  readonly " $fragmentType": "MemberGroupMoreActionsDropdownFragment";
};
export type MemberGroupMoreActionsDropdownFragment$key = {
  readonly " $data"?: MemberGroupMoreActionsDropdownFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberGroupMoreActionsDropdownFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberGroupMoreActionsDropdownFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditMemberGroupButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteSubGroupButtonFragment"
    }
  ],
  "type": "MemberGroup",
  "abstractKey": null
};

(node as any).hash = "ee82cb111e77c897efcc29a0fb4d5263";

export default node;
